import { Components } from '.generated/templates/Feature.Components.model';
import { Sitecore } from '.generated/templates/_.Sitecore.Override';
import Button from 'components/helpers/Button';
import Container from 'components/helpers/Container';
import { MissingDataSource } from 'components/helpers/EditingHelpText';
import Heading, { propsFromFields } from 'components/helpers/Heading';
import { classnames } from 'tailwindcss-classnames';
import { ButtonVariant } from 'components/helpers/Button/WithButton';

export type ContentBlockProps = Sitecore.Override.ComponentBase &
  Components.General.ContentBlock.Fields.ContentBlock;

const ContentBlock = ({ fields }: ContentBlockProps): JSX.Element => {
  if (!fields) {
    return <MissingDataSource />;
  }

  const headingProps = propsFromFields(fields);
  const ctaClasses = classnames('w-full', 'sm:w-auto', 'text-center', 'md:text-left');
  const cta2TypeField = fields.cta2Type.value;
  const cta2Type: ButtonVariant =
    cta2TypeField === 'Default' || cta2TypeField.trim().length === 0
      ? 'link'
      : (cta2TypeField.toLowerCase() as ButtonVariant);

  const flexAlignment = classnames({
    'justify-start': headingProps.headingAlignment === 'left',
    'justify-center': headingProps.headingAlignment === 'center',
    'justify-end': headingProps.headingAlignment === 'right',
  });
  return (
    <Container size="standard" dataComponent="authorable/general/content-block">
      <div>
        <Heading {...headingProps} className={classnames('mb-4')} />
        <div className={classnames('flex', 'items-baseline', 'flex-wrap', flexAlignment)}>
          <Button linkField={fields.cta1} className={classnames('mt-6', 'sm:mr-6', ctaClasses)} />
          <Button
            linkField={fields.cta2}
            variant={cta2Type}
            className={classnames('mt-4', ctaClasses)}
          />
        </div>
      </div>
    </Container>
  );
};

export default ContentBlock;
